(function () {
  if (window.__ntfSizeInStockInit) return;
  window.__ntfSizeInStockInit = true;

  /* ===== EINSTELLUNGEN ===== */
  // Wörter, an denen der Größenfilter erkannt wird (alles klein schreiben).
  var GROESSE_SCHLUESSELWOERTER = ['größe', 'grösse', 'size'];

  // Technischer Name + Wert des "Auf Lager"-Filters (Shopify-Standard, normalerweise NICHT ändern).
  var LAGER_NAME = 'filter.v.availability';
  var LAGER_WERT = '1';
  /* ========================= */

  var kundeHatSelbstAbgewaehlt = false;

  function gruppenTitel(input) {
    var gruppe = input.closest('details');
    if (!gruppe) return '';
    var titel = gruppe.querySelector('summary');
    return (titel ? titel.textContent : '').toLowerCase();
  }

  function istGroessenCheckbox(input) {
    if (!input || input.type !== 'checkbox') return false;
    if (!input.name || input.name.indexOf('filter.') !== 0) return false;
    if (input.name === LAGER_NAME) return false;
    var titel = gruppenTitel(input);
    return GROESSE_SCHLUESSELWOERTER.some(function (w) {
      return titel.indexOf(w) !== -1;
    });
  }

  document.addEventListener('change', function (event) {
    var ziel = event.target;
    if (!ziel || ziel.tagName !== 'INPUT') return;

    // Fall 1: Kunde schaltet "Auf Lager" selbst um -> Wunsch merken.
    if (ziel.name === LAGER_NAME && ziel.value === LAGER_WERT) {
      kundeHatSelbstAbgewaehlt = !ziel.checked;
      return;
    }

    // Fall 2: Kunde wählt eine Größe neu aus -> "Auf Lager" einmalig mitsetzen.
    if (istGroessenCheckbox(ziel) && ziel.checked && !kundeHatSelbstAbgewaehlt) {
      var formular = ziel.closest('form');
      if (!formular) return;
      var lagerCheckbox = formular.querySelector(
        'input[name="' + LAGER_NAME + '"][value="' + LAGER_WERT + '"]'
      );
      if (lagerCheckbox && !lagerCheckbox.checked) {
        lagerCheckbox.checked = true;
      }
    }
  });
})();